<template>
  <div class="customerSummaryLastOrder">
    <div class="customerSummaryLastOrder__title">{{ $t('customer.summary.last_order.title') }}</div>
    <div v-if="loading" class="customerSummaryLastOrder__loading">
      <sl-spinner></sl-spinner>
    </div>
    <div v-else-if="error" class="customerSummaryLastOrder__empty">
      {{ $t('customer.summary.load_error') }}
    </div>
    <!-- CustomerOrderItem owns the order row everywhere else in Wings, so the summary renders
         the same component in its compact mode rather than a second interpretation of an
         order. Clicking it opens the order details behind this overlay, hence the close. -->
    <CustomerOrderItem
      v-else-if="order"
      :order="order"
      mode="summary"
      @click="emit('open-order')"
    />
    <div v-else class="customerSummaryLastOrder__empty">
      {{ $t('customer.summary.last_order.empty') }}
    </div>
  </div>
</template>

<script setup>
import CustomerOrderItem from '@/components/Customer/CustomerOrders/CustomerOrderItem/CustomerOrderItem.vue'

defineProps({
  order: {
    type: Object,
    default: null
  },
  loading: {
    type: Boolean,
    default: false
  },
  error: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['open-order'])
</script>

<style scoped>
.customerSummaryLastOrder {
  &__title {
    font-size: var(--sl-font-size-x-small);
    color: var(--sl-color-neutral-500);
    margin-bottom: 8px;
  }

  &__empty {
    font-size: var(--sl-font-size-small);
    color: var(--sl-color-neutral-500);
  }

  &__loading {
    display: flex;
    justify-content: center;
    padding: 12px 0;
  }
}
</style>
